import { render, staticRenderFns } from "./import-success.vue?vue&type=template&id=5af6bd2c&scoped=true"
import script from "./import-success.vue?vue&type=script&lang=js"
export * from "./import-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6bd2c",
  null
  
)

export default component.exports